<template>
  <div
    :class="[
      'tw-bg-white dark:tw-bg-black apTablet3:tw-bg-ap-snow apTablet3:dark:tw-bg-ap-nero',
      'about-us-section tw-relative apTablet3:tw-pb-[383px] tw-pb-[33px]',
      'apTablet3:tw-mt-[-120px] tw-mt-0',
    ]"
  >

    <!-- About Us Content -->
    <section
      id="about-us"
      :class="[
        'tw-relative tw-flex tw-justify-center tw-transition-opacity tw-duration-500 tw-ease ',
        'tw-z-[10] tw-bg-transparent',
      ]"
    >
      <div class="apTablet3:tw-max-w-[1280px] apTablet3:tw-mx-[48px] tw-mx-6 desktop:tw-mx-[80px] tw-flex tw-flex-col">
        <!-- three vertical stars -->
        <div
          :class="[
            'tw-absolute tw-top-[-100px] tw-left-[160px] tw-flex-shrink-0',
            'tw-hidden apTablet3:tw-block',
          ]"
        >
          <img :src="stars" alt="Stars" class="tw-w-[64px] tw-h-[224px] tw-flex-shrink-0">
        </div>
        <img
          :src="topRectangle"
          alt="Top Rectangle"
          :class="[
            'tw-w-[120px] tw-h-[160px] tw-flex-shrink-0 tw-mt-[-80px] tw-opacity-0 apTablet3:tw-opacity-100',
          ]"
        >
        <!-- Title and Description Section -->
        <div class="">
          <!-- lines rectangle -->

          <h1
            id="aboutUsTitle"
            ref="aboutUsHeader"
            :class="[
              'apTablet3:tw-text-h4-bold-desktop tw-text-h4-bold-mobile',
              'tw-pb-[33px] tw-pt-16 dark:tw-text-white tw-text-ap-nero',
              'apTablet3:tw-mx-0 tw-w-full tw-mx-auto',
            ]"
          >
            Where AI is the UI
          </h1>
          <p
            :class="[
              'apTablet3:tw-text-body-desktop tw-text-body-mobile tw-mx-auto dark:tw-text-white tw-text-ap-nero ',
              'apTablet3:tw-w-[640px] tw-w-full tw-mx-auto',
            ]"
          >
            Leading the charge in digital transformation, Next offers a comprehensive suite of services catering to brands and organisations seeking cutting-edge technological solutions combined with a deep understanding of the audience psyche and strategic communication.
            <br><br>
            We believe that digital technology has the power to enhance the human experience, create meaningful impact and increase brand affinity in ways not possible with conventional marketing approaches.
          </p>
        </div>
        <div
          class="apTablet3:tw-w-[640px] tw-w-full tw-h-[1px] tw-flex-shrink-0 apTablet3:tw-mt-[80px] tw-mt-16 apTablet3:tw-mb-8 tw-mb-16 tw-bg-[#E6E6E6] dark:tw-bg-[#969696]"
        />

        <p
          :class="[
            'apTablet3:tw-text-body-desktop tw-text-body-mobile   tw-mb-22 tw-mx-auto dark:tw-text-white tw-text-ap-nero ',
            'apTablet3:tw-w-[640px] tw-w-full tw-mx-auto',
          ]"
        >
          Next is a joint venture between
          <span class="tw-font-bold">Alphapod</span>, a digital design and
          development studio and <span class="tw-font-bold">DSTNCT</span>, a
          leading marketing communications and strategy agency.<br><br>
          Together, we join forces to push the boundaries of design, technology
          and communications to unlock new possibilities for our clients and
          partners. More information about us here:
        </p>

        <div class="tw-flex-shrink-0 tw-mx-auto apTablet3:tw-pb-[160px] desktop:tw-ml-1">
          <img
            :src="collaborationLight"
            alt="Collaboration"
            class="apTablet3:tw-w-[487px] apTablet:tw-h-[64px] tw-w-full tw-h-full dark:tw-hidden tw-block"
          >
          <img
            :src="collaborationDark"
            alt="Collaboration"
            class="apTablet3:tw-w-[487px] apTablet:tw-h-[64px] tw-w-full tw-h-full dark:tw-block tw-hidden"
          >
        </div>

        <div class="tw-flex tw-flex-row tw-justify-between tw-items-center tw-pt-[33px] apTablet3:tw-hidden">
          <img
            :src="$cdn(isDarkMode ? 'images/home/img_vector_striped-circle-3.png' : 'images/home/img_vector_striped-circle-red.png')"
            :class="[
              'tw-w-[174px] tw-h-[174px] tw-ml-[-111px] desktop:tw-ml-[-180px]',
            ]"
          >
          <img
            :src="topRectangle"
            :class="[
              'tw-w-[93px] tw-h-[124px] ',
            ]"
          >
        </div>
      </div>
    </section>

    <!-- Background Elements -->
    <img
      :class="[
        'tw-w-[120px] tw-h-[160px]',
        'tw-absolute tw-top-[-80px] tw-right-[24px] apTablet:tw-right-[80px]',
        'apTablet3:tw-z-50 tw-z-40 ',
        'apTablet3:tw-hidden tw-block'
      ]"
      :src="topRectangle"
      alt="Top Rectangle"
    >

    <div
      id="about-us-white-background"
      class="tw-absolute tw-top-0 tw-left-0 tw-bg-ap-white dark:tw-bg-black tw-h-[1185px] tw-z-[9]"
      :style="{ width: `${containerWidth}px` }"
    />

    <video
      id="header-video-placeholder"
      :src="'https://cloudinary.alphapod.com/alphapod/video/upload/v1736997528/NEXT%20Website/Assets/Video/NEXT_intro_reel.h264.mp4'"
      autoplay
      muted
      loop
      playsinline
      :class="[
        'tw-absolute tw-top-[-280px]',
        'apTablet3:tw-top-[-195px]',
        'tw-max-w-[800px] tw-max-h-[800px]',
        'tw-bg-ap-gainsboro tw-z-[8] tw-rounded-full',
        'apTablet3:tw-h-[42vw] apTablet3:tw-w-[42vw] tw-h-[400px] tw-w-[400px]',
        'tw-object-cover'
      ]"
      :style="{
        left: `${videoPadLeft}px`,
      }"
    />

    <img
      id="cracked_square"
      class="tw-absolute tw-bottom-[-239px] tw-right-0 tw-z-[7] tw-hidden apTablet3:tw-block"
      :src="$cdn(isDarkMode ? 'images/home/cracked_square_dark.png' : 'images/home/cracked_square.png')"
    >

    <!-- Sidebar code (Replace with imported sidebar component at later date)-->

    <div
      id="sidebar"
      class="sidebar-expanded tw-absolute tw-top-24 tw-z-[50] tw-bg-white dark:tw-bg-black apTablet4:tw-block tw-hidden"
      :class="{ 'tw-opacity-0': !showSidebar }"
      :style="{ left: `${sideMargin}px`, transition: 'opacity 0.5s ease' }"
    >
      <div class="tw-pl-6 tw-pr-8 tw-pt-[40px] tw-pb-[32px] tw-bg-white dark:tw-bg-black">
        <div>
          <img
            :src="isDarkMode ? logoDark : logoLight"
            alt="Sidebar Logo"
            class="tw-w-[135px] tw-h-[40px] tw-cursor-pointer"
            @click="scrollToTop"
          >
        </div>

        <div class="tw-flex tw-flex-col tw-pt-18">
          <a
            v-for="(section, index) in sections"
            :key="index"
            :href="`#${section}`"
            class=""
            :class="[
              'tw-text-label-bold-desktop tw-tracking-[0.75px] tw-uppercase tw-py-2 tw-flex tw-items-center',
              activeSection === section ? 'tw-text-ap-persian-red' : 'tw-text-ap-nero dark:tw-text-white hover:tw-text-ap-persian-red',
              activeSection !== section ? 'hover:tw-text-ap-persian-red dark:hover:tw-text-ap-persian-red' : '',]"
            @click="scrollToSection(section, $event)"
          >
            <span
              v-show="activeSection === section"
              class="active-section-indicator animate__animated"
              :class="{
                'opacity-100 transform animate__zoomIn ': activeSection === section, // Apply zoomIn animation when shown
                'tw-transform-translate-x-[-100%] opacity-0 transform  animate__zoomOut': activeSection !== section, // Move it off screen when closing
              }"
            />
            <span
              :class="{
                'tw-translate-x-[4%] tw-duration-[800ms]':
                  activeSection === section,
              }"
            >
              {{ sectionLabel(section) }}
            </span>
          </a>
        </div>


        <div class="tw-flex tw-gap-4 tw-pt-18">
          <DaylightButton
            v-model:dark-mode="isDarkMode"
            :class="{
              'tw-opacity-100 hover:tw-opacity-80 hover:tw-scale-105': activeSection !== 'our-work',
              'tw-transition-all tw-duration-[500ms] tw-ease-in-out': true,
            }"
            :style="{
              pointerEvents: activeSection === 'our-work' ? 'none' : 'auto',
            }"
          /> <!-- <img ref="darkModeToggleImage" :src="isDarkMode ? darkToggleImage : lightToggleImage" alt="Toggle"
            class="tw-w-[80px] tw-h-[40px] tw-flex-shrink-0 tw-cursor-pointer" :class="{
              'tw-cursor-not-allowed tw-opacity-50': activeSection === 'our-work',
              'tw-opacity-100 hover:tw-opacity-80 hover:tw-scale-105': activeSection !== 'our-work',
              'tw-transition-all tw-duration-[500ms] tw-ease-in-out': true,
              'opacity-toggle': isToggled,
            }" @click="darkModeToggle" :disabled="activeSection === 'our-work'"
            :style="{ pointerEvents: activeSection === 'our-work' ? 'none' : 'auto' }" /> -->

          <img
            :src="isDarkMode ? darkTopImage : lightTopImage"
            alt="Top"
            class="tw-w-[40px] tw-h-[40px] tw-flex-shrink-0 tw-cursor-pointer hover:tw-opacity-80 hover:tw-scale-105"
            :class="{
              'tw-transition-all tw-duration-[1000ms] tw-ease-in-out': true, // Set transition duration to 1 second
            }"
            @click="scrollToTop"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { onBeforeUnmount, onMounted, onUnmounted, ref, watch } from 'vue';
import { cdn } from '../../support/cdn';
import { scrollToTop, watchDarkMode } from '../../support/helper';
import DaylightButton from '../shared/DaylightButton.vue';

import gsap from 'gsap';
gsap.registerPlugin(ScrollTrigger);

// Image sources for dark and light mode
const topRectangle = cdn('images/home/top_rectangle.png');
const collaborationLight = cdn('images/home/collaboration_light.png');
const collaborationDark = cdn('images/home/collaboration_dark.png');
const stars = cdn('images/home/stars.png');
const darkToggleImage = cdn('images/home/toggle-dark.svg');
const lightToggleImage = cdn('images/home/toggle-light.svg');
const darkTopImage = cdn('images/home/top-dark.svg');
const lightTopImage = cdn('images/home/top-light.svg');
const logoDark = cdn('images/home/logo_dark.svg');
const logoLight = cdn('images/home/logo_light.svg');

// States
const isDarkMode = ref(false);
const isToggled = ref(false); // Animation toggle for dark mode
const isSidebarVisible = ref(false);
const activeSection = ref(''); // Currently active section
const isScrolling = ref(false); // Tracks scrolling state
const sections = ['about-us', 'our-services', 'our-work', 'get-in-touch'];
const containerWidth = ref(0);
const sideMargin = ref(300);
const isMobile = ref(false); // Reactive state to check if it's mobile
const imageSrc = ref(cdn('images/home/collaboration_light.png'));

const videoPadLeft = ref(-80);

const props = defineProps({
  showSidebar: {
    type: Boolean,
    default: true
  },
});

const emit = defineEmits(['update:darkMode']);

const sidebarPlacement = ref(380);
let stopObserving: () => void;

function onResize() {
  isMobile.value = window.innerWidth <= 1280;
  sideMargin.value = calculateSideMargin();

  containerWidth.value = (window.innerWidth - 960) / 2 + 960;
  if (window.innerWidth > 1024) {
    sidebarPlacement.value = (window.innerWidth - 1160) / 2;
    videoPadLeft.value = window.innerWidth * 1280 / 1920;
  }
}

const calculateSideMargin = () => {
  if (window.innerWidth > 1280 && window.innerWidth <= 1440) {
    return 100; // Adjust margin specifically for 1440p
  }
  if (window.innerWidth > 1440 && window.innerWidth <= 1920) {
    return 320; // Maintain a reasonable margin for screens within this range
  }
  if (window.innerWidth <= 1280) {
    return (window.innerWidth - 1280) / 2;
  }
  return 300; // Default fallback for larger screens
};


// Function to label the sections
const sectionLabel = (section: string) => {
  switch (section) {
    case 'about-us':
      return 'About Us';
    case 'our-services':
      return 'Our Services';
    case 'our-work':
      return 'Our Work';
    case 'get-in-touch':
      return 'Get in Touch';
    default:
      return '';
  }
};

const scrollToSection = (section: string, event: MouseEvent) => {
  event.preventDefault();
  const element = document.getElementById(section);

  if (element) {
    // Give time for layout/GSAP transform to apply
    requestAnimationFrame(() => {
      const rect = element.getBoundingClientRect();
      const y = rect.top + window.scrollY;

      gsap.to(window, {
        scrollTo: { y },
        duration: 1,
        ease: 'power2.out',
        onComplete: () => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }
};

// Toggle dark mode
const darkModeToggle = () => {
  isToggled.value = true;
  setTimeout(() => (isDarkMode.value = !isDarkMode.value), 300);
  setTimeout(() => (isToggled.value = false), 600);
};

// Watch for dark mode changes
watch(isDarkMode, (newVal) => {
  document.documentElement.classList.toggle('dark', newVal);
  imageSrc.value = newVal ? collaborationDark : collaborationLight;
});

// Observe active section and toggle sidebar visibility
const observeSections = () => {
  const updateOnScroll = () => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0]; // Get the first entry (in case there are multiple observed sections)

        let newActiveSection = '';
        if (entry.isIntersecting) {
          newActiveSection = entry.target.id;
        }
        if (newActiveSection !== activeSection.value) {
          activeSection.value = newActiveSection;
          isSidebarVisible.value = newActiveSection === 'about-us'; // Show sidebar only for 'about-us'
        }
      },
      {
        root: null, // Observe relative to the viewport
        threshold: 0.5, // Trigger when 50% of the section is visible in the viewport
      }
    );

    sections.forEach((sectionId) => {
      const section = document.getElementById(sectionId);
      if (section) {
        observer.observe(section);
      }
    });

    return () => observer.disconnect();
  };
  window.addEventListener('scroll', updateOnScroll);
  updateOnScroll(); // Initial call to set the state
};


function monitorSidebarVisibility() {
  const targetElement = document.getElementById('aboutUsTitle');

  if (!targetElement) return;

  const observer = new IntersectionObserver((entries) => {
    const entry = entries[0];
    isSidebarVisible.value = entry.isIntersecting; // Update visibility state based on "About us"
  }, {
    root: null, // Observe relative to the viewport
    threshold: 0.5, // 80% visibility threshold
  });

  observer.observe(targetElement);
  return () => observer.disconnect();
}

// Initialize animations
function initAnimation() {
  if (window.innerWidth < 1025) return;

  const element1 = document.getElementById('about-us');
  const parent: HTMLElement | null = document.querySelector('.about-us-section');
  const element2 = document.getElementById('about-us-white-background');
  const sidebar = document.getElementById('sidebar');
  if (element1 && element2 && parent && sidebar) {
    const initialParentHeight = parent.clientHeight;

    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: element1,
        scrub: true,
        start: 'top bottom',
        toggleActions: 'play reverse play reverse',
        onUpdate: (self) => {
          const tick = self.progress;
          const newHeight = initialParentHeight - 900 * tick;
          parent.style.height = `${newHeight}px`;
        },
      },
    });
    timeline.to(element1, { y: -800 }, 0);
    timeline.to(element2, { y: -800 }, 0);
    timeline.to(sidebar, { y: -800 }, 0);
  }

  const element3 = document.getElementById('header-video-placeholder');
  if (element3) {
    gsap.to(element3, {
      y: -120,
      ease: 'none',
      scrollTrigger: {
        trigger: element3,
        start: 'top bottom',      // when top hits bottom of viewport
        end: 'center center',     // when center hits center of viewport
        scrub: true,              // smooth animation tied to scroll
      },
    });
  }


  const element4 = document.getElementById('cracked_square');
  if (element4) {
    gsap.to(element4, {
      y: 1500,
      ease: 'none',
      scrollTrigger: {
        trigger: element4,
        scrub: true,
        start: 'top 90%',
        toggleActions: 'play reverse play reverse',
      },
    });
  }
}

onMounted(() => {
  const cleanupSidebarObserver = monitorSidebarVisibility();

  onResize();
  window.addEventListener('resize', onResize);
  observeSections();
  initAnimation();
  stopObserving = watchDarkMode((value: any) => {
    isDarkMode.value = value;
    isToggled.value = value;
  });
  onUnmounted(() => {
    if (cleanupSidebarObserver) cleanupSidebarObserver();
  });
});

// Cleanup before component is unmounted
onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize);
  window.removeEventListener('scroll', observeSections);
});
</script>

<style scoped>
@keyframes opacity-toggle-animation {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

.opacity-toggle {
  animation: opacity-toggle-animation 500ms ease-in-out;
}

.active-section-indicator {
  background-color: #dc1e1e;
  width: 32px;
  height: 2px;
  opacity: 0;
  /* Initially hidden */
}

.animate__animated.animate__zoomOut {
  --animate-duration: 800ms;
}


a .active-section-indicator {
  opacity: 1;
}

.fade-toggle-enter-active,
.fade-toggle-leave-active {
  transition: opacity 0.6s ease-in-out;
}

.fade-toggle-enter,
.fade-toggle-leave-to

/* .fade-toggle-leave-active in <2.1.8 */
  {
  opacity: 0;
}
</style>
<style scoped>
@keyframes opacity-toggle-animation {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

.opacity-toggle {
  animation: opacity-toggle-animation 500ms ease-in-out;
}

.active-section-indicator {
  background-color: #dc1e1e;
  width: 32px;
  height: 2px;
  opacity: 0;
  /* Initially hidden */
}

.animate__animated.animate__zoomOut {
  --animate-duration: 800ms;
}


a .active-section-indicator {
  opacity: 1;
}

.fade-toggle-enter-active,
.fade-toggle-leave-active {
  transition: opacity 0.6s ease-in-out;
}

.fade-toggle-enter,
.fade-toggle-leave-to {
  opacity: 0;
}
</style>